import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

type SSRChipProps = {
  icon?: ReactNode;
  title: ReactNode;
  subText?: ReactNode;
  extraText?: ReactNode;
  extraInfo?: ReactNode;
  value?: string;
  hasSelection?: boolean;
  onClick?: () => void;
};

const SSRChip = ({ icon, title, subText, hasSelection, onClick }: SSRChipProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-background-default flex w-full flex-col items-stretch justify-between gap-4 rounded-md p-4 md:flex-row md:flex-wrap md:items-center md:p-5">
        <div className="flex items-start gap-3 md:items-center">
          <div className="rounded-xs bg-background-primary-lighter text-icon-active flex size-10 shrink-0 items-center justify-center p-2 md:size-12">
            {icon}
          </div>
          <div className="flex flex-col gap-0.5">
            <div className="text-font-default text-base font-medium md:text-lg">{title}</div>
            <div className="text-12 text-font-subtle">{subText}</div>
          </div>
        </div>
        <div className="flex w-full shrink-0 items-center gap-3 md:w-auto">
          <button
            onClick={onClick}
            className="text-font-active bg-background-default w-full cursor-pointer rounded-md py-3 font-semibold outline outline-current md:w-30 md:rounded-xs md:p-1"
          >
            {t(hasSelection ? "Flights.details.ssr.editType" : "Flights.details.ssr.addType", { type: title })}
          </button>
        </div>
      </div>
    </>
  );
};

export default SSRChip;
